import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _MILEAGE_UNIT_LABEL, _MILEAGE_LABEL, _MILES_LABEL, _MILE_LABEL;

export var MILEAGE_TYPE = {
  MILES: 'MILES',
  KM: 'KM'
};
var MILEAGE_UNIT_LABEL = (_MILEAGE_UNIT_LABEL = {}, _defineProperty(_MILEAGE_UNIT_LABEL, MILEAGE_TYPE.MILES, 'mi'), _defineProperty(_MILEAGE_UNIT_LABEL, MILEAGE_TYPE.KM, 'km'), _MILEAGE_UNIT_LABEL);
var MILEAGE_LABEL = (_MILEAGE_LABEL = {}, _defineProperty(_MILEAGE_LABEL, MILEAGE_TYPE.MILES, 'Mileage'), _defineProperty(_MILEAGE_LABEL, MILEAGE_TYPE.KM, 'Kms'), _MILEAGE_LABEL);
var MILES_LABEL = (_MILES_LABEL = {}, _defineProperty(_MILES_LABEL, MILEAGE_TYPE.MILES, 'Miles'), _defineProperty(_MILES_LABEL, MILEAGE_TYPE.KM, 'Kms'), _MILES_LABEL);
var MILE_LABEL = (_MILE_LABEL = {}, _defineProperty(_MILE_LABEL, MILEAGE_TYPE.MILES, 'Mile'), _defineProperty(_MILE_LABEL, MILEAGE_TYPE.KM, 'Km'), _MILE_LABEL);
export var mileageLabelConfig = function mileageLabelConfig(mileageMeasure) {
  return {
    getMileageUnitLabel: function getMileageUnitLabel() {
      return MILEAGE_UNIT_LABEL[mileageMeasure] || 'mi';
    },
    getMileageLabel: function getMileageLabel() {
      return MILEAGE_LABEL[mileageMeasure] || 'Mileage';
    },
    getMilesLabel: function getMilesLabel() {
      return MILES_LABEL[mileageMeasure] || 'Miles';
    },
    getMileLabel: function getMileLabel() {
      return MILE_LABEL[mileageMeasure] || 'Mile';
    }
  };
};